import React from "react";
import "./AftersalesCard.css";

export default function AftersalesCard({ imageSrc, subtitle }) {
    return (
        <article className="aftersales-card">
            <div className="aftersales-card__media">
                <img src={imageSrc} alt={subtitle} className="aftersales-card__img" />
            </div>
            <div className="aftersales-card__content">
                <h3 className="aftersales-card__subtitle">{subtitle}</h3>
            </div>
        </article>
    );
}
